import React, {useRef} from "react";
import HubspotForm from 'react-hubspot-form';
import {useI18next, useTranslation} from 'gatsby-plugin-react-i18next';

export const SubscribeForm = () => {
  const hubspotFormRef = useRef(null);
  const {t} = useTranslation();
  const {language} = useI18next();

  return (
    <HubspotForm
      locale={language}
      ref={hubspotFormRef}
      portalId='2784460'
      formId='0e9e383c-151d-4d4e-9179-2e656b108db7'
      cssClass="position-relative subscribe-form"
      submitButtonClass="btn btn-white position-absolute subscribe-form__btn"
      loading={<div>{t("Loading...")}</div>}
    />
  )
}
